import { useState } from "react";
import { cn } from "../utils/cn";
import Container from "./container";

export default function Oportunidades() {
    const [selectedIndex, setSelectedIndex] = useState(0);

  const opportunities = [
    {
      label: "Identificação de oportunidades",
      icon: "../assets/icones/finep/finep4.png",
      content: [
        {
          title: "Análise de Elegibilidade:",
          description:
            "A partir dos objetivos estratégicos e as capacidades inovadoras de cada empresa, desenvolvemos avaliações detalhadas identificando projetos que se qualificam para financiamento do FINEP.",
        },
        {
          title: "Mapeamento de Necessidades:",
          description:
            "Conectamos as necessidades e objetivos da empresa com as áreas de fomento disponíveis, assegurando que o projeto proposto seja altamente relevante e tenha um grande potencial de aprovação.",
        },
      ],
    },
    {
      label: "Desenho de Projetos Inovadores",
      icon: "../assets/icones/finep/finep1.png",
      content: [
        {
          title: "Consultoria Estratégica:",
          description:
            "Oferecemos consultoria especializada para desenhar projetos que atendam aos requisitos específicos da FINEP, integrando inovação tecnológica com objetivos de negócio claros.",
        },
        {
          title: "Definição de Escopo:",
          description:
            "Trabalhamos em conjunto com a equipe do cliente para definir o escopo do projeto, detalhando objetivos, metas, cronograma, orçamento e resultados esperados.",
        },
      ],
    },
    {
      label: "Elaboração e Submissão de Propostas",
      icon: "../assets/icones/finep/finep2.png",
      content: [
        {
          title: "Documentação Completa:",
          description:
            "Preparamos toda a documentação necessária, incluindo propostas técnicas, planos de negócio, justificativas de inovação e impacto esperado.",
        },
        {
          title: "Orientação e Suporte:",
          description:
            "Fornecemos orientação contínua durante todo o processo de submissão, garantindo que todas as exigências sejam cumpridas e que a proposta seja apresentada de forma clara e convincente.",
        },
      ],
    },
    {
      label: "Gestão e Acompanhamento de Projetos",
      icon: "../assets/icones/finep/finep3.png",
      content: [
        {
          title: "Gerenciamento de Projetos:",
          description:
            "Oferecemos serviços de gerenciamento de projetos para assegurar que os cronogramas e orçamentos sejam rigorosamente respeitados e que os marcos e metas sejam alcançados.",
        },
        {
          title: "Relatórios e Auditorias:",
          description:
            "Apoiamos na preparação de relatórios periódicos e na realização de auditorias exigidas pela FINEP, assegurando conformidade e transparência durante todo o ciclo do projeto.",
        },
      ],
    },
  ];

  return (
    <section className="bg-[#040116] text-white">
      <Container className="hidden py-16 md:grid md:grid-cols-2 gap-12">
        <div className="border-l-4 border-[#2A2A2F] ps-6 space-y-4 relative">
          {opportunities.map((opportunity, index) => (
            <div
              key={index}
              className={cn(
                "flex items-center gap-3.5 px-6 py-3 rounded-[14px] w-fit cursor-pointer transition-all duration-300",
                index === selectedIndex
                  ? "bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#4B3BDB]"
                  : "hover:bg-[#2A2A2F]/40",
              )}
              onClick={() => setSelectedIndex(index)}
            >
              <img src={opportunity.icon} alt="" />
              <span className="text-xl text-white">{opportunity.label}</span>
            </div>
          ))}

          <div className="bg-[#4B3BDB] w-1 h-9 absolute -left-1 top-4" />
        </div>
        <div className="space-y-7">
          <article className="space-y-12">
            {opportunities[selectedIndex].content.map((item, idx) => (
              <div key={idx}>
                <h3 className="block font-inter-bold text-xl">{item.title}</h3>
                <p className="text-[#9CA8BB]">{item.description}</p>
              </div>
            ))}
          </article>
          <button
            type="button"
            className="font-inter-light text-white rounded-full bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] p-[1px] hover:scale-105 transition-all duration-300 hover:cursor-pointer"
          >
            <a href="/">
              <div className="bg-[#2b283d] rounded-full px-8 py-2">
                Otimize seu negócio!
              </div>
            </a>
          </button>
        </div>
      </Container>
      <Container className="pt-16 pb-10 md:hidden">
        {opportunities.map((opportunity, index) => (
          <div key={index}>
            <div
              className={cn(
                "mb-5",
                index === opportunities.length - 1 && "mb-0",
                index === selectedIndex && "m-0",
              )}
            >
              <div
                className={cn(
                  "flex w-full items-center gap-3.5 px-6 py-3 rounded-[14px] h-fit cursor-pointer transition-all duration-300",
                  index === selectedIndex
                    ? "bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#4B3BDB] justify-center"
                    : "ring-1 ring-white",
                )}
                onClick={() => setSelectedIndex(index)}
              >
                <img
                  src={opportunity.icon}
                  alt=""
                  className="size-5 object-contain aspect-square"
                />
                <span className="text-sm text-white">{opportunity.label}</span>
              </div>
              {index === selectedIndex && (
                <div className="py-9 px-9 space-y-10">
                  {opportunities[selectedIndex].content.map((item, idx) => (
                    <div key={idx} className="space-y-2">
                      <h3 className="block font-inter-bold">{item.title}</h3>
                      <p className="text-[#9CA8BB] text-sm font-inter-regular">
                        {item.description}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </Container>
    </section>
  );
}
